import React, { useState, useRef } from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // Import the plugin for jsPDF
import IconButton from '../../elements/IconButton';
import Button from '../../elements/Button';
import CBALogo from '../../media/images/CBALogo.png'

const Main = (props) => {
    const [loadedData, setLoadedData] = useState([]);
    const [stillGettingData, setStillGettingData] = useState(0);
    const isCancelled = useRef(false); // Used to track if fetching was cancelled

    console.log(props)

    console.log(props)

    const handleCancelFetch = () => {
        isCancelled.current = true; // Set flag to true when fetching is cancelled
    };

    const fetchAllData = (exportType) => {
        let skip = 0;
        const limit = 999999;
        let allData = [];
        setStillGettingData(1);

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({
                user_ID: props.userId,
            })
        };

        props.tokenSafeAPIRequest(
            `${props.url}${props.specific ? '/' + props.specific : ''}?limit=${limit}&fetch_links=true&skip=${skip}&sort_field=${props.sort}&start_date=${props.calStartDate}&end_date=${props.calEndDate}&active_only=false`,
            requestOptions,
            '',
            (result, status) => {
                if (exportType === 'CSV') {
                    downloadCSV(result, props.exportKeys, props.fileTitle);
                } else if (exportType === 'PDF') {
                    downloadPDF(result, props.exportKeys, props.fileTitle);
                }
            })


    };

    const processResult = (data, onCompletion) => {
        console.log(data)
        if (data && data.length > 0) {
            setLoadedData((loadedData) => [...loadedData, ...data]);
            onCompletion(true, data);
        } else {
            onCompletion(false);
        }
    };

    function formatNumber(value) {
        try {
            // Attempt to convert the input to a number
            const num = parseFloat(value);
            // Check if the conversion resulted in a valid number
            if (!isNaN(num)) {
              // Use Intl.NumberFormat for US-style number formatting with two decimal places
              return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(num);
            } else {
              // Return a default value if the input is not a valid number
              return '0.00';
            }
          } catch (e) {
            // In case of any unexpected errors, return a default value
            return '0.00';
          }
    }

    const getMonthsReferenced = (startDate, endDate) => {
        if (!startDate || !endDate) return 0;

        const [startYear, startMonth] = `${startDate}`.split('T')[0].split('-').map(Number);
        const [endYear, endMonth] = `${endDate}`.split('T')[0].split('-').map(Number);

        if (!startYear || !startMonth || !endYear || !endMonth) return 0;
        return Math.max(0, (endYear - startYear) * 12 + endMonth - startMonth + 1);
    };

    const convertPayeeToUser = (payee, user, spiffee, dealership) => {
        if (payee === null) {return 'No User'}
        if (payee === 0) {return spiffee.name}
        if (payee === 1) {return dealership.name}
        if (payee === 2) {return user === null ? 'No Agent':(user?.first_name + ' ' + user?.last_name)}
        if (payee === 3) {return 'Inside Sales'}
    }

    const getDealerDisplayName = (dealer, split) => {
        const dealerName = dealer?.name || (typeof dealer === 'string' ? dealer : '');
        return split ? `${dealerName} - (Split)` : dealerName;
    };

    const downloadCSV = (data, keys, filename = 'data.csv') => {
        const year = data.range_end ? `${data.range_end}`.split('-')[0] : '';
        const meetingTitle = year ? `${year} ANNUAL AGENCY MEETINGS` : 'ANNUAL AGENCY MEETINGS';
        const reportedMonths = Number(data.months) || getMonthsReferenced(data.range_start, data.range_end);
        const userLine = data.user?.name
            ? `${data.user.name} - ${reportedMonths} MONTH${reportedMonths === 1 ? '' : 'S'}`
            : `${reportedMonths} MONTH${reportedMonths === 1 ? '' : 'S'} REFERENCED`;
        const totalContracts = data.total_contract_count ?? 0;
        const signupsLine = `${year} SIGN UPS - ${totalContracts} (0 FRANCHISE, ${totalContracts} INDEPENDENTS)`;
        const adminTotals = Array.isArray(data.admin_totals) ? data.admin_totals : [];

        const rows = Array.isArray(data.stores)
            ? data.stores.flatMap((store) =>
                (store.rows || []).map((row) => ({ ...row, dealer: store.dealership, split: store.split }))
            )
            : [];

        const csvLines = [];
        csvLines.push([meetingTitle]);
        csvLines.push([userLine]);
        csvLines.push([signupsLine]);
        csvLines.push([]);
        csvLines.push(['Admin Contract Counts']);
        csvLines.push(['Admin', 'Contracts']);

        adminTotals.forEach((adminTotal) => {
            csvLines.push([
                adminTotal.admin?.code || adminTotal.admin?.name || '',
                adminTotal.cba_cc ?? '',
            ]);
        });

        csvLines.push([]);
        csvLines.push(['Dealer', 'Admin', 'Code', 'Amount']);

        rows.forEach((row) => {
            const dealerName = getDealerDisplayName(row.dealer, row.split);
            const adminName = row.admin?.name || (typeof row.admin === 'string' ? row.admin : '');
            const adminCode = row.admin?.code || '';
            const amount = typeof row.avg_net_per_month !== 'undefined'
                ? `$${formatNumber(row.avg_net_per_month)}`
                : (typeof row.amount !== 'undefined' ? `$${formatNumber(row.amount)}` : '');

            csvLines.push([
                dealerName,
                adminName,
                adminCode,
                amount,
            ]);
        });

        const escapeCsvValue = (value) => {
            const stringValue = value == null ? '' : String(value);
            return `"${stringValue.replace(/"/g, '""')}"`;
        };

        const csvContent = csvLines
            .map((line) => line.map(escapeCsvValue).join(','))
            .join('\r\n');
    
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };
    
    const downloadPDF = async (data, keys, filename = 'data.pdf') => {
        const doc = new jsPDF({ orientation: 'landscape' });

        // helper to fetch image as dataURL
        const getImageDataUrl = async (url) => {
            try {
                const res = await fetch(url);
                const blob = await res.blob();
                return await new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(blob);
                });
            } catch (e) {
                return null;
            }
        };

        const leftMargin = 10;
        const rightMargin = 10;
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const contentWidth = pageWidth - leftMargin - rightMargin;
        let cursorY = 12;

        // Try to load CBALogo and draw top-left and top-right
        const logoData = await getImageDataUrl(CBALogo).catch(() => null);
        // CBALogo is a wide image. Keep its natural ratio so it is not stretched.
        const logoAspectRatio = 1360 / 880;
        const logoH = 24;
        const logoW = logoH * logoAspectRatio;
        if (logoData) {
            try {
                doc.addImage(logoData, 'PNG', leftMargin, cursorY - 8, logoW, logoH);
                doc.addImage(logoData, 'PNG', pageWidth - rightMargin - logoW, cursorY - 8, logoW, logoH);
            } catch (e) {
                // ignore image errors
            }
        }

        // Title
        const year = data.range_end ? `${data.range_end}`.split('-')[0] : '';
        const meetingTitle = year ? `${year} ANNUAL AGENCY MEETINGS` : 'ANNUAL AGENCY MEETINGS';
        doc.setFontSize(24);
        doc.setFont('helvetica', 'bold');
        const titleWidth = doc.getTextWidth(meetingTitle);
        doc.text(meetingTitle, leftMargin + contentWidth / 2 - titleWidth / 2, cursorY + 8);
        cursorY += 18;

        // User name line
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        const reportedMonths = Number(data.months) || getMonthsReferenced(data.range_start, data.range_end);
        const userLine = data.user?.name
            ? `${data.user.name} - ${reportedMonths} MONTH${reportedMonths === 1 ? '' : 'S'}`
            : `${reportedMonths} MONTH${reportedMonths === 1 ? '' : 'S'} REFERENCED`;
        doc.text(userLine, leftMargin + contentWidth / 2 - doc.getTextWidth(userLine) / 2, cursorY + 6);
        cursorY += 12;

        // Sign ups summary line (smaller)
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        const totalContracts = data.total_contract_count ?? 0;
        const signupsLine = `${year} SIGN UPS - ${totalContracts} ( 0 FRANCHISE, ${totalContracts} INDEPENDENTS)`;
        doc.text(signupsLine, leftMargin + contentWidth / 2 - doc.getTextWidth(signupsLine) / 2, cursorY + 6);
        cursorY += 12;

        // Admin contract counts as compact boxed items (small font)
        const adminTotals = Array.isArray(data.admin_totals) ? data.admin_totals : [];
        if (adminTotals.length > 0) {
            const cols = 3;
            const gap = 6;
            const columnWidth = (contentWidth - gap * (cols - 1)) / cols;
            const horizontalPadding = 1.5;
            const boxHeight = 12;
            const rowsOfAdmins = Math.ceil(adminTotals.length / cols);

            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');

            adminTotals.forEach((adm, idx) => {
                // Fill each row left-to-right before starting the next one.
                const col = idx % cols;
                const row = Math.floor(idx / cols);
                const columnX = leftMargin + col * (columnWidth + gap);
                const y = cursorY + row * (boxHeight + 6);
                const text = `${adm.admin?.code || ''} - ${adm.cba_cc ?? ''}`;
                const boxWidth = Math.min(columnWidth, doc.getTextWidth(text) + horizontalPadding * 2);
                const x = columnX + (columnWidth - boxWidth) / 2;
                doc.setDrawColor(0);
                doc.setLineWidth(0.6);
                doc.rect(x, y, boxWidth, boxHeight);
                doc.text(text, x + boxWidth / 2, y + 8, { align: 'center' });
            });

            cursorY += rowsOfAdmins * (boxHeight + 6) + 6;
        }

        // Build rows for Dealer / Admin / Code / Amount
        let rows = [];
        if (Array.isArray(data.stores)) {
            data.stores.forEach((dealer) => {
                const updatedRows = (dealer.rows || []).map((row) => ({ ...row, dealer: dealer.dealership, split: dealer.split }));
                rows.push(...updatedRows);
            });
        }

        const transactionsTableData = rows.map((r) => {
            const dealerName = getDealerDisplayName(r.dealer, r.split);
            const adminName = r.admin?.name || (typeof r.admin === 'string' ? r.admin : '');
            const adminCode = r.admin?.code || '';
            const amount = typeof r.avg_net_per_month !== 'undefined' ? `$${formatNumber(r.avg_net_per_month)}` : (r.amount ? `$${formatNumber(r.amount)}` : '');
            return [dealerName, adminName, adminCode, amount];
        });

        // If no rows, add sample rows to keep layout
        if (transactionsTableData.length === 0) {
            transactionsTableData.push(['Alan Besco Cars Trucks (IS) (1 mth)', '', 'US', '$775']);
            transactionsTableData.push(['One Hour Auto (4 mth)', '', 'LS', '$290']);
            transactionsTableData.push(['MGM Auto Sales (2 mth)', '', 'US', '$100']);
        }

        doc.autoTable({
            startY: cursorY,
            head: [['Dealer', 'Admin', 'Code', 'Amount']],
            body: transactionsTableData,
            styles: { fontSize: 10 },
            headStyles: { fillColor: [255,255,255], textColor: 20, fontStyle: 'bold' },
            columnStyles: {
                0: { cellWidth: contentWidth * 0.5 },
                1: { cellWidth: contentWidth * 0.25 },
                2: { cellWidth: contentWidth * 0.1 },
                3: { halign: 'right', cellWidth: contentWidth * 0.15 },
            },
            theme: 'plain',
            didParseCell: function(tableData) {
                // Keep the Amount heading directly above the right-aligned values.
                if (tableData.column.index === 3) {
                    tableData.cell.styles.halign = 'right';
                }
            },
            didDrawCell: function(data) {
                if (data.section === 'body') {
                    data.cell.styles.lineColor = [255,255,255];
                }
            }
        });

        // Footer page numbers
        const addPageNumbers = (doc) => {
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(9);
                doc.setTextColor(120);
                doc.text(`Page ${i}`, pageWidth - rightMargin - 20, pageHeight - 10);
            }
        };

        addPageNumbers(doc);
        doc.save(filename);
    };

    const downloadExcel = () => {
        let baseURL = 'https://cba-api-prod-v1.thinetics.io';
        if (window.location.hostname === 'cba-frontend-dev.pages.dev' || window.location.hostname === 'localhost') {
            baseURL = 'https://cberman-api-dev.thinetics.io';
        }

        let url = baseURL + '/metrics/agent_sheets/export?user_ID=' + props.userId;
        //sentinel dates mean "All Times": leave them off so the backend uses
        //its default range (January through the current month)
        if (props.calStartDate !== '2000-01-01' && props.calEndDate !== '2200-01-01') {
            url += '&start_date=' + props.calStartDate + '&end_date=' + props.calEndDate;
        }

        setStillGettingData(1);
        fetch(url, { headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') } })
            .then((response) => {
                if (!response.ok) { throw new Error('Export failed: ' + response.status); }
                return response.blob();
            })
            .then((blob) => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = (props.fileTitle || 'Agent Wall Sheet') + '.xlsx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
                setStillGettingData(0);
            })
            .catch((error) => {
                console.log(error);
                setStillGettingData(0);
            });
    };

    return (
        <div style={{ width: '360px', height: 'auto', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flexBasis: '10%', display: 'flex', flexDirection: 'row' }}>
                <span style={{ fontWeight: '500', fontSize: '20px', flexBasis: '99%' }}>Export Report</span>
                <IconButton img={false} colors={props.colors} Style={{ borderRadius: '3px', backgroundColor: props.colors.border, width: '24px' }} size="16px">
                    <div onClick={() => { handleCancelFetch(); props.setIsOpen() }} style={{ paddingLeft: '3px', paddingRight: '3px' }}><span onClick={() => { handleCancelFetch(); props.setIsOpen() }}>x</span></div>
                </IconButton>
            </div>
            <div style={{ flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <span style={{ fontWeight: '500', fontSize: '16px' }}>Downloaded Rows: {loadedData.length}</span>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => downloadExcel()}>Download CSV</Button>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => fetchAllData('PDF')}>Download PDF</Button>
            </div>
        </div>
    );
};

export default Main;
